<template>
  <div class="detail">
    <div class="left">
      <div class="container">
        <el-form :model="ruleForm" ref="ruleForm" label-width="120px" class="demo-ruleForm" :rules="rules">
          <el-card class="card-item box-card">
            <div class="card-title clearfix" slot="header">
              <span>基本信息</span>
            </div>
            <div class="card-content">
              <el-row>
                <el-col :span="22">
                  <el-form-item label="所属交易中心：" prop="tradeOrgId">
                    <el-select v-model="ruleForm.tradeOrgId" clearable placeholder="请选择" @change="chtradeOrgList">
                      <el-option v-for="item in tradingCenterList" :key="item.id" :label="item.tradeOrgName"
                        :value="item.tradeOrgId">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="100">
                  <el-form-item label="场地：" prop="allfieldCode">
                    <el-table :data="tableData" border stripe :height="tableMaxHeight"
                      style="width: 800px; margin-top: 16px" :header-cell-class-name="cellClass"
                      @selection-change="handleSelectionChange">
                      >
                      <el-table-column type="selection" header-align="center" align="center" fixed width="150">
                      </el-table-column>

                      <el-table-column type="index" label="序号" header-align="center" align="center"
                        show-overflow-tooltip width="180" >
                        <template slot-scope="scope">
                          {{ ((pageIndex - 1) * pageSize) + scope.$index + 1 }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="name" label="场地名称" header-align="center" align="center">
                      </el-table-column>
                    </el-table>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                      :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" layout="total,prev, pager, next"
                      :page-size="pageSize" :total="totalNumber">
                    </el-pagination>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-card>
          <el-card class="card-item box-card">
            <div class="card-title clearfix" slot="header">
              <span>安排时间信息</span>
            </div>
            <div class="card-content" style="height: 400px; margin-top: 20px">
              <el-row>
                <el-col :span="20">
                  <el-form-item label="类型：" prop="timetypelistvalue">
                    <el-select v-model="ruleForm.timetypelistvalue" placeholder="请选择" @change="gettimetypelisttype">
                      <el-option v-for="item in timetypelist" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="20">
                  <el-form-item label="选择日期：" prop="datearrangement" v-if="ruleForm.timetypelistvalue === 1" >
                    <el-date-picker v-model="ruleForm.datearrangement" type="date" value-format="yyyy-MM-dd" 
                      placeholder="选择日期" style="width: 202px" @change="getdatearrangement"
                      :key="ruleForm.datearrangement">
                    </el-date-picker>
                  </el-form-item>

                  <!-- 开始时间 和结束时间 --> 
                  <el-form-item label="选择时段：" v-if="ruleForm.timetypelistvalue === 2" prop="timeframe" >
                    <el-date-picker v-model="ruleForm.timeframe"  
                    type="daterange" range-separator="至" 
                      start-placeholder="开始日期" end-placeholder="结束日期" style="width: 404px" value-format="yyyy-MM-dd"
                      @change="gettimeframe">
                    </el-date-picker>
                  </el-form-item>

                  <!-- 每周 每月 -->
                  <el-form-item label="选择时间：" v-if="ruleForm.timetypelistvalue === 3 " prop="timedschedulingvalue">
                    <!-- 每周  每月 -->
                    <el-select v-model="ruleForm.timedschedulingvalue" placeholder="请选择" @change="gettimedschedulingtype">
                      <el-option v-for="item in timedschedulinglist" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>


                    <!-- 每周 -->
                    <el-select v-model="ruleForm.weeklyvalue" placeholder="请选择"
                      v-if="ruleForm.timedschedulingvalue === 1" @change="setweeklytimetypelistvalue">
                      <el-option v-for="item in weeklylist" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>

                    <!-- 每月日期 -->
                    <el-date-picker  v-model="ruleForm.monthlyvalue"
                    :key="ruleForm.monthlyvalue"
                    class="custom-datepicker" :append-to-body="false" type="date" placeholder="选择日期"
                      format="d" value-format="d" style="width: 202px"
                      v-if="ruleForm.timedschedulingvalue === 2" @change="setmonthlytimetypelistvalue" >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <!-- 安排时段 上午 下午 全天 -->
                <el-col :span="20">
                  <!-- v-if="ruleForm.timetypelistvalue === 1 ||ruleForm.timetypelistvalue === 2 || ruleForm.timedschedulingvalue === 2 || ruleForm.timedschedulingvalue === 1"  -->
                  <el-form-item label="安排时段："  prop="scheduletimevalue">
                    <el-select v-model="ruleForm.scheduletimevalue" placeholder="请选择">
                      <el-option v-for="item in Scheduletimelist" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="20">
                  <p style="font-size: 16px; margin-top: 50px">
                    注意:<br />
                    1、场地支持全选; <br />
                    2、可根据实际情况，按单日、时段或定时进行场地安排;<br />
                    3、可根据实际情况，分为上午、下午或全天进行场地安排;<br />
                    4、提交后，根据设置的场地、日期及时段，控制代理无法进行预约。
                    <span style="color: red">但对已预约的数据不产生效果</span><br />
                  </p>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-form>
      </div>
    </div>
    <div class="btns">
      <ul>
        <li><a href="#">场地安排</a></li>
      </ul>

      <el-button type="primary" @click="saveInformation(ruleForm)">保存信息</el-button>

      <el-button @click.native="tabsCloseCurrentHandle">返回</el-button>
    </div>
  </div>
</template>
<script>
import { infoBaseList } from "@/server/field";
import { tabsCloseCurrentHandle } from "@/utils/routeTab";

export default {
  data() {
    return {
      // 页码
      pageIndex: 1,
      pageSize: 5,
      totalNumber: 0,
      rows: 10,
      tableMaxHeight: document.documentElement.clientHeight - 640,
      tableData: [],
      ruleForm: {
        tradeOrgId: "", //所属交易中心
        timetypelistvalue: 1, //安排时间选择类型
        timetypelistvaluecopy:1,
        datearrangement: "", //按1类型 选的日期数据
        timeframe: "", //按2类型 选的时段数据
        scheduletimevalue: null, //按1类型 选的时段 上午 下午 全天
        allfieldCode: [],
        timedschedulingvalue: null, //每周每月的类型值
        weeklyvalue: 1, //每周数值
        monthlyvalue: '1', //每月数值
      },


      timeOrder: 0,
      // 每周每月数值
      weeklymonthlyvalue:null,
      // 开始时间
      timeframestartTime: '',
      // 结束时间
      timeframeendTime: '',

      tradingCenterList: [], //交易中心数据

      timetypelist: [
        {
          value: 1,
          label: "按日期安排",
        },
        {
          value: 2,
          label: "按时段安排",
        },
        {
          value: 3,
          label: "定时安排",
        },

      ],
      Scheduletimelist: [
        {
          value: 1,
          label: "上午",
        },
        {
          value: 2,
          label: "下午",
        },
        {
          value: 3,
          label: "全天",
        },
      ],

      // 定时安排

      timedschedulinglist: [
        {
          value: 1,
          label: "每周",
        },
        {
          value: 2,
          label: "每月",
        },
      ],

      weeklylist: [
        {
          value: 1,
          label: "周一",
        },
        {
          value: 2,
          label: "周二",
        },
        {
          value: 3,
          label: "周三",
        },
        {
          value: 4,
          label: "周四",
        },
        {
          value: 5,
          label: "周五",
        },
        {
          value: 6,
          label: "周六",
        },
        {
          value: 7,
          label: "周日",
        },
      ],

      rules: {
        tradeOrgId: [
          { required: true, message: "请选择活动区域", trigger: "change" },
        ],

        // 安排时间选择校验
        timetypelistvalue: [
          { required: true, message: "请选择类型", trigger: "change" },
        ],

        // 安排时间类型1日期校验
        datearrangement: [
          { required: true, message: "请选择日期", trigger: "change", },
        ],

        // 选择时段
        timeframe: [
          // { required: true, message: "请选择时段", trigger: "blur" },
          { type: 'array', required: true, message: '请选择时段', trigger: 'blur'}
        ],

        scheduletimevalue: [
          { required: true, message: "请选择安排时段", trigger: "change" },
        ],

        allfieldCode: [
          { required: true, message: "请至少选择一个场地", trigger: "change", },
        ],


        timedschedulingvalue: [
          { required: true, message: "请选择时间", trigger: "change" },
        ]


      },



      dialogVisible: false,
      type: "",
    };
  },
  activated() { 
      this.gettradingCenterList(item => {

      this.tradingCenterList = []

      });


  },
  created() { 

      this.gettradingCenterList();


  },
  mounted() {
    
 
    // if (this.$route.query.id) {
    //   this.getDetailMessage();
    // }

  },
  computed: {
    // 序号累计
    getIndex(){
        if (this.pageIndex > 1) {
          return (this.pageIndex - 1) * this.pageSize + index + 1;
        } else {
          return index + 1;
        }
    },
    // 根据每周每月的选择值去请求携带对应的数值
    coptimedschedulingvalue() {
      // timedschedulingvalue: "1", //每周每月的类型值
      //   weeklyvalue:"", //每周数值
      //   monthlyvalue: "", //每月数值
      switch (this.ruleForm.timedschedulingvalue) {
        case 1:
          return this.ruleForm.weeklyvalue;
        case 2:
          return Number(this.ruleForm.monthlyvalue);
        default:
          return 0;
      }
    },

    // 安排时间类型
    scheduletimetype() {
      switch (this.ruleForm.timetypelistvalue) {
        case 1:
          return this.ruleForm.datearrangement;

        case 2:
          return this.ruleForm.timeframe;

        default:
          return "";
      }
    },

    // 每周每月日的数据转换
    coweeklymonthly() {
      switch (this.ruleForm.timetypelistvalue) {
        case 3:
          return this.ruleForm.weeklyvalue
        case 4:
          return Number(this.ruleForm.monthlyvalue);
        default:
        return 0;
      }
    },

    // 每周每月日数据转化值
    coweeklymonthlyvalue(){
      switch (this.ruleForm.timetypelistvaluecopy) {
        case 3:
        return this.weeklymonthlyvalue = this.ruleForm.weeklyvalue
         case 4:
         return this.weeklymonthlyvalue = Number(this.ruleForm.monthlyvalue);
        default:
        return  0
      }
    },

    // 判断安排时段
    coscheduletimevalue() {
      if (!this.ruleForm.scheduletimevalue) {
        return 0;
      } else {
        return this.ruleForm.scheduletimevalue;
      }
    },
  },
  methods: {
    // 表格全选文字
    cellClass(row) {
      if (row.columnIndex === 0) {
        return "disabledCheck";
      }
    },
    // 获取所有交易中心数据
    gettradingCenterList() {
      // 获取列表数据
      this.loading = true;
      const supperAdmin = this.$store.state.user.userinfo.supperAdmin;
      infoBaseList({
        page: this.pageIndex,
        rows: this.pageSize,
        filter: {
          tradeOrgId: supperAdmin
            ? ""
            : this.$store.state.user.userinfo.orgInfo.orgId,
        },
      }).then((res) => {
        this.loading = false;
        if (res.data.code) {
          this.$message.error(res.data.msg);
          return;
        }
        const { data } = res;
        this.tradingCenterList = data.rows || [];
        // this.paginationOpt.total = data.total || 0;
      });
    },

    // 获取所属交易中心数值
    chtradeOrgList() {


      //   请求场地列表数据
      this.$http
        .post("/field/info/list", {
          page: this.pageIndex,
          rows: this.pageSize,
          filter: {
            tradeOrgId: this.ruleForm.tradeOrgId,
          },
        })
        .then((res) => {
      
          this.tableData = res.data.rows;
          this.totalNumber = res.data.total
          
          // res.data.data.supporting = res.data.data.supporting.split(",");
          // this.ruleForm = res.data.data;
        });
    },

    // 表格全选事件
    handleSelectionChange(val) {
      this.ruleForm.allfieldCode = val.map((item) => item.code).join(",");


    },

    handleSizeChange(val) {

      this.pageSize = val;
      this.chtradeOrgList();
    },

    handleCurrentChange(val) {
 
      this.pageIndex = val;
      this.chtradeOrgList();
    },

    //返回列表页
    tabsCloseCurrentHandle() {
      this.$router.push("/scheduleList");
    },

    // 选择日期时间
    getdatearrangement(){
      this.ruleForm.timetypelistvaluecopy = 1
    },

    // 获取时段
    gettimeframe() {
   
      this.ruleForm.timetypelistvaluecopy = 2
      let [startDate, endDate] = this.ruleForm.timeframe;
      this.timeframestartTime = startDate
      this.timeframeendTime = endDate



    },  


    // 根据类型选择设置类型值
    gettimetypelisttype(){
      // if (this.ruleForm.timetypelistvalue === 3) {
      //   this.ruleForm.timetypelistvaluecopy = 3
      // } 

      switch (this.ruleForm.timetypelistvalue) {
        case 3:  
        this.ruleForm.timetypelistvaluecopy = 3
        // 下面赋值为初始化，是为了防止类型选择后缓存，导致选择3后 timetypelistvaluecopy值就为3了，月的值不选择，提交只会提交周的数据
        this.ruleForm.timedschedulingvalue = 1  //周月的显示
        this.ruleForm.monthlyvalue = ''  //月的值
        this.ruleForm.weeklyvalue = null //周的值
          break;
          case 2:
        this.ruleForm.timetypelistvaluecopy = 2
          this.gettimeframe()
          break;
        default:
          break;
      }
    },

    // 根据选择时间设置类型值·
    gettimedschedulingtype(){

      if (this.ruleForm.timedschedulingvalue === 2) {
        this.ruleForm.timetypelistvaluecopy = 4
      }
    },


    // 选择每周的话设置setweeklytimetypelistvalue为3
    setweeklytimetypelistvalue() {

      this.ruleForm.timetypelistvaluecopy = 3
  

    },

    // 选择每月日期的话设置setweeklytimetypelistvalue为4
    setmonthlytimetypelistvalue() {
      this.ruleForm.timetypelistvaluecopy = 4
    
    },


    // 保存信息事件
    saveInformation(ruleForm) {
    
      switch (this.ruleForm.timetypelistvaluecopy) {
        case 1:
          this.scheduletimeone();
          return;
        case 2:
          this.scheduletimetwo();
          return;
        case 3:
          this.scheduletimethree();
          return;
        case 4:
          this.scheduletimethree();
          return;
        default:
          break;
      }
    },

    // 安排时间类型为1的方法
    scheduletimeone() {
      this.$refs["ruleForm"].validate((valid) => {

        if (valid) {
          this.$http
            .post("/fieldorder/saveOrUpdate", {
              endTime: this.scheduletimetype, //限制方式为12的话必填，日期
              fieldCode: this.ruleForm.allfieldCode, //必填  多个的话中间以，分割，我传给你的也是这样的
              startTime: this.scheduletimetype, //限制方式为12的话必填，日期
              timeOrder: this.coptimedschedulingvalue, //限制方式为34的话必填，每周填1-7每月填1-31
              timeType: this.coscheduletimevalue, //必填   1上午2下午3全天
              tradeId: this.ruleForm.tradeOrgId, //必填
              type: this.ruleForm.timetypelistvaluecopy, //必填
            })
            .then((res) => {
              if (res.data.code == 1) {
                this.$message.success(res.data.msg);
                this.unifieddata()
                this.$router.push({name:'scheduleList'});
              } else {
                this.$message.warning("网络异常，请稍后再试");
              }
            });
        } else {
          this.$message.warning("请填写必填选");
          return false;
        }
      });
    },

    // 安排时间类型为2的方法
    scheduletimetwo() {

      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$http
            .post("/fieldorder/saveOrUpdate", {
             
              endTime: this.timeframeendTime, //限制方式为12的话必填，日期
              fieldCode: this.ruleForm.allfieldCode, //必填  多个的话中间以，分割，我传给你的也是这样的
              startTime: this.timeframestartTime, //限制方式为12的话必填，日期
              timeOrder: this.coptimedschedulingvalue, //限制方式为34的话必填，每周填1-7每月填1-31
              timeType: this.coscheduletimevalue, //必填   1上午2下午3全天
              tradeId: this.ruleForm.tradeOrgId, //必填
              type: this.ruleForm.timetypelistvaluecopy, //必填
            })
            .then((res) => {
              if (res.data.code == 1) {
                this.$message.success(res.data.msg);
                this.unifieddata()
                this.$router.push({name:'scheduleList'});
              } else {
                this.$message.warning("网络异常，请稍后再试");
              }
            });
        } else {
          this.$message.warning("请填写必填选");
          return false;
        }
      });
    },

    // 安排时间类型为3的方法
    scheduletimethree() {
  
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$http
            .post("/fieldorder/saveOrUpdate", {
              endTime: this.scheduletimetype, //限制方式为12的话必填，日期
              fieldCode: this.ruleForm.allfieldCode, //必填  多个的话中间以，分割，我传给你的也是这样的
              startTime: this.scheduletimetype, //限制方式为12的话必填，日期
              timeOrder: this.coweeklymonthlyvalue, //限制方式为34的话必填，每周填1-7每月填1-31
              timeType: this.coscheduletimevalue, //必填   1上午2下午3全天
              tradeId: this.ruleForm.tradeOrgId, //必填
              type: this.ruleForm.timetypelistvaluecopy, //必填
            })
            .then((res) => {
              if (res.data.code == 1) {
                this.$message.success(res.data.msg);
                this.unifieddata()
                this.$router.push({name:'scheduleList'});
              } else {
                this.$message.warning("网络异常，请稍后再试");
              }
            });
        } else {
          this.$message.warning("请填写必填选");
          return false;
        }
      });
    },


    // 统一清空数据方法
    unifieddata(){
      this.ruleForm = [];
      this.tableData = [];
      this.ruleForm.timetypelistvaluecopy= 1 ;
    },



    applyChange(id) {
      this.$confirm("是否发起场地变更？", "提示").then((ok) => {
        if (ok) {
          this.$http
            .get("/field/applymanagechg/change?id=" + id)
            .then((res) => {
              if (res.data.code == 1) {
                this.$router.push({
                  name: "siteChangeExit",
                  query: { id: res.data.data.id },
                });
              } else {
                this.$message.error(res.data.msg);
              }
            });
        }
      });
    },
  },

};
</script>
<style lang="scss" scoped>
/* 去掉全选按钮 */
::v-deep .el-table .disabledCheck .cell::before {
  position: absolute;
  content: "全部";
  right: 26px;
}

::v-deep(.custom-datepicker) .el-date-picker__header {
  display: none;

}

::v-deep(.custom-datepicker) .el-picker-panel .el-date-picker .el-popper {
  transform-origin: center bottom;
    z-index: 2027;
    position: absolute;
    top: 511px;
    left: 539px;
}








// ::v-deep .el-picker-panel .el-date-picker .el-popper {
//   transform-origin: center bottom !important;
//   z-index: 2007 !important;
//   position: absolute !important;
//   bottom: 491px !important;
//   left: 741px !important;
// }

// ::v-deep .el-date-picker__header {
//   display: none !important;
// }

.detail {
  width: 1360px;
  display: flex;
  margin: 18px auto;

  .left {
    width: 1200px;

    .card-item {
      width: 100%;
      margin-top: 15px;
    }

    .demo-ruleForm {
      display: flex;
      flex-wrap: wrap;
      padding: 0;

      .el-form-item {

        /deep/ .el-input-number--medium,
        /deep/ .el-date-editor,
        /deep/ .el-input,
        /deep/ .el-input--medium .el-input__inner {
          width: 100%;
        }
      }

      .el-form-item:nth-last-child(2) {
        width: 100%;
      }
    }

    /deep/ .el-radio {
      margin-right: 4px !important;
    }
  }

  .btns {
    width: 150px;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background-color: #fff;
    color: #303133;
    text-align: center;
    padding: 0 10px 10px 10px;
    position: fixed;
    right: 150px;
    top: 143px;

    .el-button--medium {
      width: 100px;
      margin: 5px 0;
    }

    ul {
      width: 100px;
      margin-bottom: 5px;

      li {
        a {
          display: block;
          padding: 10px 0;
          text-align: center;
          border-bottom: 1px solid #ddd;
          position: relative;
          color: #1f59a3;
          cursor: pointer;
        }
      }
    }
  }

  .examine {
    .btn {
      margin-top: 20px;
      text-align: right;
    }

    .el-textarea {
      width: 80%;
    }
  }
}

@media screen and (max-width: 1680px) {
  .detail {
    .left {
      width: 1070px;
    }

    .btns {
      right: 80px;
    }
  }
}

@media screen and (max-width: 1600px) {
  .detail {
    .left {
      width: 950px;
    }

    .btns {
      right: 80px;
    }
  }
}

@media screen and (max-width: 1440px) {
  .detail {
    .left {
      width: 800px;
    }

    .btns {
      right: 110px;
    }
  }
}
</style>